module.exports = __webpack_public_path__ + "img/ic-google-mini-logo.0d357dd9.svg";